import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { tap, map, catchError, flatMap } from 'rxjs/operators';
import { Etapa, Desconexion, Diagnostico } from './diagnostico/Diagnostico.entity';
import { Capa } from './solucion/Capa.entity';
import { Dimension } from './solucion/Dimension.entity';
import { RespuestaTipo, RespuestaTipoOpciones, Pregunta, Respuesta } from './cuestionario/cuestionario.entity';
import { TipoDesconexion } from './solucion/solucion.entity';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/retry';
import {PlatformLocation } from '@angular/common';

class ResponseHTTP {
  constructor(
    public ResponseMessage: string,
    public Results: any,
    public ResponseCode: string
  ) {} }
@Injectable()
export class CuestionarioHttpServicesService {

 private API_URL = environment.API_URL;
 public currentEtapa: Etapa = null;
 constructor(private _httpClient: HttpClient,
  platformLocation: PlatformLocation) {
    if (environment.production) {
      this.API_URL = (platformLocation as any).location.origin + environment.API_URL ;
    }
  }

 // notice the <T>, making the method generic
 get<T>(url, params?): Observable<T> {
  return this._httpClient
  // this.API_URL +
      .get<T>(url, {params})
      .retry(3) // optionally add the retry
      .catch((err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          // console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }

        // ...optionally return a default fallback value so app can continue (pick one)
        // which could be a default value
        // return Observable.of<any>({my: "default value..."});
        // or simply an empty observable
        return Observable.empty<T>();
      });
 }
    getdata(Entidad: string) {
      return this.get(this.API_URL + '/api/'.concat(Entidad)).map((res: Response) => res.json());
    }

    getCapas(): Observable<Capa[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/Layer')
      .pipe(tap( x => x ), //  console.log('En el tap de Layer ', x.Results)
       map( res => <Capa[]>res.Results  ) // ,
      // tap( x => console.log(x) )
);
  }

  getDimension(): Observable<Dimension[]> {
    // console.log(this.API_URL + '/api/Dimension');
      return this.get<ResponseHTTP>(this.API_URL + '/api/Dimension' )
               .pipe(tap( x => x ), // console.log('En el tap de dimension ', x.Results) ),
                map( res => <Dimension[]>res.Results  ) // ,
                // .map(obj => obj.Results.json() as Dimension[] )),
               // tap( x => console.log(x) )
    );
                        // new Dimension(obj.Results.dimensionID,
                    // obj.descripcion,
                    // obj.isCompleted)) ),
  }
    getEtapa(): Observable<Etapa[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/Stage')
                .pipe(tap( x => x ),
                map( res => <Etapa[]>res.Results  ) ,
              // .map(al => new Etapa(al.etapaD, al.descripcion, al.leyenda,
              //    al.leyenda2, al.hasChild, al.isCompleted)) ),
               //  tap( x => console.log(x) )
    );
  }
  getCurrentEtapa(diagID): Observable<Etapa[]> {
 // const data = 'clienteID=' + clienteID ;
      return this.get<ResponseHTTP>(this.API_URL + '/api/Stage/ByDiagnosticoId/' + diagID)
      .pipe(tap( x => x ),
        map( res => <Etapa[]>res.Results  ) // ,
      // tap( x => console.log(x) )
      );
}
    getRespuestaTipo():  Observable<RespuestaTipo[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/ReplyType')
      .pipe(tap( x => x ),
       map( res => <RespuestaTipo[]>res.Results  ) // ,
       // .map(obj => obj.Results.json() as Dimension[] )),
      // tap( x => console.log(x) )
);

  }
    getRespuestaTipoOpciones():  Observable<RespuestaTipoOpciones[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/RespuestaTipoOpciones')
      .pipe(tap( x => x ),
       map( res => <RespuestaTipoOpciones[]>res.Results  ) // ,
       // .map(obj => obj.Results.json() as Dimension[] )),
      // tap( x => console.log(x) )
);
  }
    getPreguntas():  Observable<Pregunta[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/Question')
      .pipe(tap( x => x ),
       map( res => <Pregunta[]>res.Results  ) // ,
       // .map(obj => obj.Results.json() as Dimension[] )),
      // tap( x => console.log(x) )
);
  }
  getRespuestas(diagID: number):  Observable<Respuesta[]> {
    // const data = 'clienteID=' + clienteID ;
    return this.get<ResponseHTTP>(this.API_URL + '/api/ReplyValue/ById/' + diagID)
    .pipe(tap( x => x ),
     map( res => <Respuesta[]>res.Results  ) // ,
    // tap( x => console.log(x) )
);
}
getDiagnosticosxCliente(clienteID: number):  Observable<number> {
  return this.get<ResponseHTTP>(this.API_URL + '/api/ReplyValue/DiagnosticosxCliente/' + clienteID)
  .pipe(tap( x => x ),
   map( res => <number>res.Results  ) // ,
  // tap( x => console.log(x) )
); }

getResumenDesconexion(clienteID: number):  Observable<TipoDesconexion[]> {
  return this.get<ResponseHTTP>(this.API_URL + '/api/ResumenDesconexion/' + clienteID)
  .pipe(tap( x => x ),
   map( res => <TipoDesconexion[]>res.Results  ) // ,
  // tap( x => console.log(x) )
);
  }
  getDesconexion():  Observable<Desconexion[]> {
    return this.get<ResponseHTTP>(this.API_URL + '/api/Disconnection')
    .pipe(tap( x => x ),
     map( res => <Desconexion[]>res.Results  ) // , tap( x => console.log(x) )
  );
    }
    getDiagnosotico():  Observable<Diagnostico[]> {
      return this.get<ResponseHTTP>(this.API_URL + '/api/Diagnosotico')
      .pipe(tap( x => x ),
       map( res => <Diagnostico[]>res.Results  ) // , tap( x => console.log(x) )
    );
      }
// getCliente():  Observable<Cliente[]> {
//         return this.get<ResponseHTTP>(this.API_URL + '/api/Customer')
//         .pipe(tap( x => x ),
//          map( res => <Cliente[]>res.Results  ) // , tap( x => console.log(x) )
//       );
//         }
UpdateRespuesta(resp: Respuesta): Observable<void>   {
  // console.log(resp);
  const url = this.API_URL + '/api/ReplyValue';
  const al = new Respuesta(resp.respuestasValorID, null, resp.clienteID,
                  resp.respuestaTipoID, resp.respuestaTipoOpcionID, null , null, resp.preguntasID,
                  null, resp.etapaID , resp.diagnosticoID , resp.valor);
  // console.log(url, al);
  return this._httpClient.put<void>(url, al)
  .catch((err: HttpErrorResponse) => {
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
    }

    // ...optionally return a default fallback value so app can continue (pick one)
    // which could be a default value
    // return Observable.of<any>({my: "default value..."});
    // or simply an empty observable
    return Observable.empty<void>();
  });
}
AddRespuesta(resp: Respuesta): Observable<void>   {
    const url = this.API_URL + '/api/ReplyValue/Post';
    const al = new Respuesta(resp.respuestasValorID, null, resp.clienteID,
      resp.respuestaTipoID, resp.respuestaTipoOpcionID, null, null, resp.preguntasID,
      null, resp.etapaID , resp.diagnosticoID , resp.valor);
      // console.log(url, al);
      return this._httpClient.post<void>(url, al)
      .catch((err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
        // ...optionally return a default fallback value so app can continue (pick one)
        // which could be a default value
        // return Observable.of<any>({my: "default value..."});
        // or simply an empty observable
        return Observable.empty<void>();
      });
  }
  }



// WEBPACK FOOTER //
// ./src/app/cuestionario-http-services.service.ts